{
  "advisor.confirmation": "Auditor Confirmation",
  "advisor.confirmation.none.uploaded": "No auditor confirmation is uploaded",
  "back.to.reports": "Back to Reporting",
  "sivaAdmin": "SIVA admin",
  "sivaAdmin.funds": "Allocated funds",
  "sivaAdmin.confirmation": "Confirmation",
  "budget": "Budget",
  "budget.heading": "Budget and Accountant Confirmation",
  "budget.none.uploaded": "No budget is uploaded",
  "budget.download": "Download budget",
  "budget.upload": "Upload",
  "budget.upload.confirmation.text": "In budget year {{ year }} this file was uploaded",
  "budget.upload.confirmation.text.fileName.changes": "We have changed the file name to",
  "budget.upload.deadline": "Deadline for uploading",
  "budget.upload.error.description": "Something went wrong during the file upload, please try again.",
  "budget.upload.error.title": "Something went wrong!",
  "budget.year": "Budget year",
  "goals.updateAll": "Update all goals",
  "company.details.contract.addNewContract": "Add new contract",
  "company.details.contract.backToIdeasOrContracts": "Back to all ideas or contracts",
  "company.details.contract.changePhase": "Change phase",
  "company.details.contract.revertPhase": "Undo phase change",
  "company.details.contract.deleteContract": "Delete contract",
  "company.details.contract.editContract": "Edit",
  "company.details.contract.editContract.admissionNote": "Admission date cannot be changed. If you need help you can contact us on",
  "company.details.contract.editContract.errormodal.header": "Sorry, we could not update the contract",
  "company.details.contract.editContract.successmodal.text": "The contract has been updated",
  "company.details.contract.revertContract.warning": "This action will reset the latest registered phase change. If relevant, it will also remove the date for exit forms/customer satisfaction surveys.",
  "company.details.contract.revertContract.cantUndo": "Notice: This action cannot be undone.",
  "company.details.contract.endContract": "End",
  "company.details.contract.endContract.error": "Sorry, we couldn't end the contract",
  "company.details.contract.endContract.success": "The contract has been ended",
  "company.details.contract.overview.admissionDate": "Admission date",
  "company.details.contract.overview.dispatchAdmissionForm": "Dispatch of admission form",
  "company.details.contract.overview.dispatchEnRouteForm": "Dispatch of en route form",
  "company.details.contract.overview.dispatchExitForm": "Dispatch of exist form",
  "company.details.contract.overview.error.header": "Sorry, we could not find the contract",
  "company.details.contract.overview.error.text": "Please try again or reach us on",
  "company.details.contract.overview.exitDate": "Exit date",
  "company.details.contract.overview.exitDate.required": "Choose an exit date for this company",
  "company.details.contract.overview.id": "ID",
  "company.details.contract.overview.ideaName": "Idea name",
  "company.details.contract.overview.ideaSource": "Idea source",
  "company.details.contract.overview.ideaSource.none": "Not set",
  "company.details.contract.overview.selfDeclaration": "Self declaration",
  "company.details.contract.overview.selfDeclarationValidTo": "Valid to: {{date}}",
  "company.details.contract.overview.ongoingContract": "Ongoing contract",
  "company.details.contract.overview.info": "Contract information",
  "company.details.contract.overview.contact": "Contact",
  "company.details.contract.overview.followUp": "Follow up",
  "company.details.contract.overview.dates": "Dates",
  "company.details.contract.others.ingress": "Below are all contracts attached to this company.",
  "company.details.esa.bill.add": "Add bill",
  "company.details.esa.bill.edit": "Edit bill",
  "company.details.esa.bill.delete": "Delete selected",
  "company.details.esa.bill.noRegistered": "No bills registered",
  "company.details.esa.bill.notification.success": "Bills registered",
  "company.details.esa.bill.notification.generic": "ESA-reporting cannot be changed for the selected year",
  "company.details.esa.billedDeductible": "Billed deductible",
  "company.details.esa.header": "ESA-report for",
  "company.details.esa.marketValue": "Market value",
  "company.details.esa.marketValueDeliveredServices": "Market value on delivered services",
  "company.details.esa.summary": "Summary",
  "company.details.esa.sumInnovationSupport": "Sum innovation support",
  "company.details.esa.sumReceivedInnovationSupport": "Sum received innovation support",
  "company.details.esa.supportIntensity": "Support intensity",
  "company.details.esa.supportIntensityWarning": "Support intensity surpasses 75%",
  "company.details.esa.supportIntensityWarningWithPhase": "Support intensity surpasses 75% for the company in {{phase}}",
  "company.details.esa.total": "Total",
  "company.details.historic.ChangedFromTo": "Changed from {{from}} to {{to}}",
  "company.details.historic.contractConcluded": "Contract is concluded",
  "company.details.historic.contractRestored": "Contract is restored",
  "company.details.historic.ideaConcluded": "Idea is concluded",
  "company.details.historic.ideaRestored": "Idea is restored",
  "company.details.historic.None": "No historic available.",
  "company.details.historic.Registered": "is registered",
  "company.details.sidenav.contracts_one": "Contract",
  "company.details.sidenav.contracts_other": "Other contracts",
  "company.details.sidenav.ESAReporting": "ESA-reporting",
  "company.details.sidenav.GoalAchievement": "Goal achievement",
  "company.details.sidenav.info": "Company info",
  "dataExtract": "Data extract",
  "download.file.error": "Could not download file. Please try again.",
  "error.acceptedDateAfterRegisteredDate": "Accepted date must be after registered date {{readableRegistrationDate}}",
  "error.support.message": "Please try again or reach us on",
  "extract.targetNumber.exportButton": "Export excel data extract for",
  "extract.targetNumber.header": "Target number extract table",
  "export.goalAccomplishment.header": "Export goal accomplishment",
  "export.goalAccomplishment.exportButton": "Export goal accomplishment for",
  "export.ideasAndCompanies.header": "Export ideas and companies",
  "export.ideasAndCompanies.exportButton": "Download total report",
  "export.ideasAndCompanies.yearLabel": "Total report for",
  "export.ktu.exportButton": "Download KTU-report",
  "export.ktu.header": "Customer satisfaction survey (KTU)",
  "export.reportingYear": "Reporting year",
  "reporting.status.closeYear": "Close reporting year",
  "reporting.status.openYear": "Open reporting year",
  "reporting.status.closedToast": "Closed {{year}} for {{actorCount}} actors.",
  "reporting.status.openedToast": "Opened {{year}} for {{actorCount}} actors.",
  "reporting.status.error": "Something went wrong. Refresh the page to see the status.",
  "file.none.choosen": "No file type is selected",
  "file.type": "File type",
  "file.type.plural": "File types",
  "files": "Files",
  "hide.previous.files": "Hide previous files",
  "idea.mainContact": "Main contact",
  "idea.name": "Idea name*",
  "idea.edit": "Edit idea",
  "ideaSource.industri": "Industry",
  "ideaSource.Import": "Imported",
  "ideaSource.øvrig-næringsliv": "Other business",
  "ideaSource.fou": "R&D (University, college, research institute)",
  "ideaSource.selvstendig-grunder": "Independent entrepreneur(s)",
  "ideaSource.annet": "Other",
  "networkLogo": "Network logo",
  "notification.siva.summary.report": "Siva has given you feedback on target numbers for {{ year }}.",
  "notification.siva.summary.report.url": "Read comments.",
  "search.Operatorname": "Search for operator name",
  "show.previous.files": "View previous files",
  "type.choose": "Select type",
  "upload.files": "Upload files",
  "upload.file": "Upload file",
  "upload.file.drag": "or drag it here",
  "report.deadline": "Deadline for registration of",
  "report.goals": "Goals",
  "report.goals.positive": "Positiv endring",
  "report.goals.negative": "Negativ endring",
  "report.goals.unchanged": "Uendret måltall",
  "report.goals.difference.higher": "The new value is higher by +{{difference}}",
  "report.goals.difference.higherPercentage": "The new value is higher by +{{difference}} percentage points",
  "report.goals.difference.lower": "The new value is lower by {{difference}}",
  "report.goals.difference.lowerPercentage": "The new value is lower by {{difference}} percentage points",
  "report.goals.difference.unchanged": "The new value is the same as the previous one",
  "report.goalsAndBudget": "Reporting of goals and budget",
  "report.goals.eu.negative": "Negativ",
  "report.goals.eu.positive": "Positiv",
  "report.goals.eu.none": "None",
  "report.goals.export.potensiale": "No, but with export potential",
  "report.goals.export.underleverandor": "No, but is a subcontractor to an export company",
  "targetNumber": "Target number",
  "siva.offseasonHeadline": "A new reporting solution is on the way",
  "siva.offseasonIntro1": "We are working iteratively on features for a new reporting solution",
  "siva.offseasonIntro2": "If you would like to provide feedback on existing or upcoming features, send us a message at <1>{{email}}</1>",
  "notification.siva.summary.approved": "Siva have approved your target numbers for {{ year }}",
  "notification.siva.summary.approved.url": "See target numbers {{ year }}",
  "ideasAndCompanies.title": "Ideas and companies",
  "ideasAndCompanies.notFound": "No ideas or companies are registert",
  "add.idea": "Create idea",
  "add.company": "Create",
  "add.ideaOrCompany": "Add idea or company",
  "add.idea.error": "Something went wrong during the creation of the idea. Please try again.",
  "add.company.error": "Something went wrong during the creation of the company. Please try again.",
  "phase.Idea": "Idea",
  "phase.PreIncubation": "Preincubation",
  "phase.Incubated": "Incubation company",
  "phase.ScaleUp": "Scale up",
  "phase.Alumni": "Alumni",
  "phase.OtherPhases": "Other phases",
  "choose.phase": "All phases",
  "changePhase.success.text": "Phase has been changed from",
  "changePhase.error.title": "Sorry, we couldn't change phase",
  "changePhase.error.text": "Please try again or contact us if the error continues",
  "changePhase.selfDeclaration.error.title": "Sorry, we couldn't save the self declaration",
  "changePhase.selfDeclaration.error.text": "The phase change was saved, but saving the self declaration failed. Please try again or contact us if the error continues",
  "idea.description": "Idea description",
  "newIdeaForm.fromDate.label": "Registrationdate*",
  "newIdeaForm.fromDate.required": "Choose a registrationdate for the idea",
  "newIdeaForm.name.label": "Name*",
  "newIdeaForm.name.required": "Write a short description of the idea",
  "newIdeaForm.ideaSource.label": "Idea source*",
  "newIdeaForm.ideaSource.required": "Choose what source the ideas comes from",
  "newIdeaForm.ideaSource.helpText": "Please enter where the idea sources from",
  "newIdeaForm.contactFirstName.label": "First name*",
  "newIdeaForm.contactFirstName.required": "Enter the first name of the idea holder",
  "newIdeaForm.contactLastName.label": "Last name*",
  "newIdeaForm.contactLastName.required": "Enter the last name of the idea holder",
  "newIdeaForm.contactEmail.label": "Email*",
  "newIdeaForm.contactEmail.required": "Enter the email address of the idea holder",
  "newIdeaForm.contactEmail.validateEmail": "Enter a valid email address of the idea holder",
  "newCompany.contract.form.municipality.label": "Municipality",
  "newIdeaForm.advisorId.label": "Advisor*",
  "newIdeaForm.advisorId.required": "Choose an advisor that will follow up the idea",
  "newIdeaForm.notes.label": "Notes (optional)",
  "newIdeaForm.notes.maxLength": "The notes can maximum be 1000 characters",
  "newIdeaForm.section.title.contact": "Contact",
  "newIdeaForm.section.subTitle.contact": "Contact information of the idea holder",
  "newIdeaForm.section.title.followUp": "Follow up",
  "newIdeaDialog.title.confirmation": "Confirmation",
  "newIdeaDialog.title.error": "Sorry, could not create idea",
  "newIdeaDialog.error.text": "Please try again, and contact oss at <1>{{ value }}</1>",
  "newIdeaDialog.error.buttonText": "Try again",
  "newIdeaDialog.buttons.addNew": "Add new idea",
  "newIdeaDialog.buttons.closeAndGoBack": "Close and go back to overview",
  "newIdeaDialog.text": "The idea is created.",
  "newCompany.baseInfoBox.orgNo": "Org no.:",
  "newCompany.baseInfoBox.address": "Address:",
  "newCompany.baseInfoBox.noAddress": "No address found",
  "newCompany.contract.form.name.required": "A name is required if no company has been added ",
  "newCompany.contract.section.info.title": "Contract information",
  "newCompany.contract.form.ideaSource.label": "Idea source",
  "newCompany.contract.form.ideaSource.required": "Idea source is required for ideas",
  "newCompany.contract.form.ideaSource.placeholder": "Choose idea source...",
  "newCompany.contract.form.externalIndustry.placeholder": "Choose industry...",
  "newCompany.contract.form.registrationDate.label": "Registration date",
  "newCompany.contract.form.errors": "There are one or more errors in the form. Please review it and try again.",
  "newCompany.dialog.text.created": "Contract created",
  "no.ceo": "No CEO",
  "companyTabs.economy.salesIncome": "Sales income",
  "companyTabs.economy.balance": "Balance",
  "companyTabs.economy.valueCreation": "Value creation",
  "companyTabs.economy.operationalResults": "Operational results",
  "companyTabs.economy.salaryExpenses": "Salary expenses",
  "companyTabs.economy.enterpriseStatus": "Enterprise status",
  "companyTabs.tabs.about": "About the company",
  "companyTabs.tabs.register": "Registers",
  "companyTabs.tabs.economy": "Accounting",
  "companyTabs.tabs.applications": "Previous applications",
  "companyTabs.error.loadingFailed": "Could not load company information. Please contact support if the error persists.",
  "companyTabs.about.registeredDate": "Registration date",
  "companyTabs.applications.table.title": "Previous grants and applications",
  "choose.advisor": "All advisors",
  "overviewTabs.ideas": "All ideas",
  "overviewTabs.contracts": "All companies",
  "overviewTabs.targetCompanies": "All target companies",
  "overviewTabs.alumni": "All alumni",
  "overviewTabs.esaReporting": "ESA-reporting",
  "phase.select": "Choose phase",
  "contract.edit.connectCompany": "Connect to company",
  "contract.edit.noCompany.text": "No org. number, will add company with an org. number later.",
  "contract.edit.noCompany.ariaLabel": "No company with org number, will add later.",
  "reporting.selfdeclaration": "Self declaration",
  "reporting.selfdeclaration.classification": "Self classification",
  "reporting.selfdeclaration.Title": "Have you obtained a self declaration?",
  "reporting.selfdeclaration.dialog.title": "Register updated self declaration",
  "reporting.selfdeclaration.deliveredDate": "Delivered date",
  "reporting.selfdeclaration.registerUpdatedQuestion": "A self declaration already exists for this contract. Do you want to register an updated one?",
  "reporting.selfdeclaration.registerUpdatedConfirm": "Register updated",
  "reporting.selfdeclaration.Required": " You must have obtained a self declaration to register a company",
  "reporting.selfdeclaration.Associated": "Associated",
  "reporting.selfdeclaration.Independent": "Independent",
  "reporting.selfdeclaration.Partner": "Partner",
  "goalAccomplishment.Total.YearError": "Cannot update total accomplishment for previous years",
  "ideasAndCompanies.terminateChosenIdeas": "Terminate chosen ideas",
  "ideasAndCompanies.wantToTerminate": "Do you want to terminate",
  "ideasAndCompanies.chosenIdeasSingular": "chosen idea? This vil be terminated effective immediately.",
  "ideasAndCompanies.chosenIdeasPlural": "chosen ideas? These vil be terminated effective immediately.",
  "ideasAndCompanies.terminate": "Terminate ideas",
  "ideasAndCompanies.reopenChosenIdeasCompanies": "Reopen chosen ideas/companies",
  "ideasAndCompanies.wantToReopen": "Do you want to reopen",
  "ideasAndCompanies.chosenIdeasCompaniesSingular": "chosen idea/company?",
  "ideasAndCompanies.chosenIdeasCompaniesPlural": "chosen ideas/companies?",
  "ideasAndCompanies.reopenChosen": "Reopen chosen",
  "ideasAndCompanies.reopenIdeasCompanies": "Reopen ideas/companies",
  "ideasAndCompanies.generalErrorMessage": "An error has occurred. Please try again later. If the error persists, contact us.",
  "ideasAndCompanies.generalErrorHeader": "Error",
  "ideasAndCompanies.ideasTerminatedPlural.header": "{{ count }} ideas are terminated",
  "ideasAndCompanies.ideasTerminatedPlural.text": "The ideas are moved to All alumni and can be reopened from there.",
  "ideasAndCompanies.ideasTerminatedSingular.header": "{{ count }} ideas are terminated",
  "ideasAndCompanies.ideasTerminatedSingular.text": "The idea is moved to All alumni and can be reopened from there.",
  "ideasAndCompanies.ideasCompaniesReopenedPlural": "{{ count }} inactive ideas/companies are reopened",
  "ideasAndCompanies.ideasCompaniesReopenedSingular": "{{ count }} inactive idea/company is reopened",
  "goalAccomplishment.edited": "Edited accomplishments",
  "ideasAndCompanies.reportingDone.header": "Reporting for {{ year }}",
  "ideasAndCompanies.reportingDone.text": "Mark as finished when you have completed the reporting for {{ year }}.",
  "ideasAndCompanies.reportingDone.desc": "You can read more about how yearly reporting works in Flerbedriftsportalen in the Help and Support sidebar to the right.",
  "ideasAndCompanies.reportingDone.finished": "Finished",
  "ideasAndCompanies.reportingDone.notFinished": "Not finished",
  "ideasAndCompanies.goalsAndBudget.header": "Goals and budget reporting {{ year }}",
  "ideasAndCompanies.resultsMetrics.header": "Results metrics",
  "ideasAndCompanies.changesAreAutomatic.text": "The changes are automatically saved at.",
  "ideasAndCompanies.reportingYearIsClosed.text": "This reporting year is closed and cannot be edited. Contact Siva if you need to correct target achievement.",
  "ideasAndCompanies.editResults.buttonText": "Edit results",
  "ideasAndCompanies.exitEditing.buttonText": "Exit editing",
  "ideasAndCompanies.internationalMarketOptionPositive.text": "Yes",
  "ideasAndCompanies.internationalMarketOptionNegative.text": "No",
  "ideasAndCompanies.internationalMarketOptionPotential.text": "No, but has international market potential",
  "hasOnlyBeenIdea": "Has only been idea?",
  "ideasAndCompanies.delete.confirm": "Are you sure you want to delete {{ contract }}?",
  "newCompany.brregSearch.search.label": "Search in The Brønnøysund Register Centre",
  "newCompany.contract.form.ideaName.maxLength": "Idea name cannot exeed {{value}} characters. Use the notes box for notes.",
  "admittedToProgram": "Admitted to program",
  "ideaConsidered": "Idea considered",
  "programAdmission.title": "Program admission",
  "programAdmission.cannotAdmit.title": "Cannot admit inquiry",
  "programAdmission.cannotAdmit.text": "To admit to a program, you must first connect a company.",
  "programAdmission.connectCompany": "Connect company",
  "programAdmission.addedToast": "{{name}} with phase {{phase}} was added.",
  "programAdmission.noAvailablePhases.businessGarden": "{{name}} already has a contract. Only one contract can be registered per company.",
  "programAdmission.noAvailablePhases.incubator": "{{name}} already has a contract in a phase other than {{phase}}. Only one phase can be registered per company, except {{phase}}.",
  "newCompany.contract.form.name.label": "Idea name",
  "newCompany.contract.form.name.description": "A short description of the business idea. This will be shown in the company overview",
  "newCompany.contract.form.externalIndustry.label": "Industry",
  "newCompany.contract.form.externalIndustry.required": "Please specify which industry the company belongs to.",
  "newCompany.contract.form.fromDate.label": "Admission date",
  "newCompany.contract.form.fromDate.required": "Choose a date for admission of this company",
  "newCompany.contract.form.fromDate.sameYear": "You can only choose a date in the current year.",
  "newCompany.contract.form.formStartupDate.label": "Dispatch of admission form",
  "newCompany.contract.form.formMidDate.label": "Dispatch of en route form",
  "newCompany.contract.section.contact.title": "Contact",
  "newCompany.contract.form.contactFirstName.label": "First name",
  "newCompany.contract.form.contactFirstName.required": "Enter the first name of the contact person",
  "newCompany.contract.form.contactLastName.label": "Last name",
  "newCompany.contract.form.contactLastName.required": "Enter the last name of the contact person",
  "newCompany.contract.form.contactEmail.label": "Email",
  "newCompany.contract.form.contactEmail.required": "Enter the email address of the contact person",
  "newCompany.contract.form.contactEmail.validateEmail": "Enter a valid email address for the contact person",
  "newCompany.contract.section.followUp.title": "Follow up",
  "newCompany.contract.form.advisorId.required": "Choose an advisor to follow up the company (this contract or project)",
  "newCompany.contract.form.advisorId.link.text": "Can't find the advisor? You can add employees in",
  "newCompany.contract.form.notes.label": "Note",
  "newCompany.contract.form.notes.label.description": "The note will be visible in the activity log",
  "newCompany.contract.form.notes.maxLength": "The note can be a maximum of 1000 characters",
  "newCompany.buttons.complete": "Complete and add company"
}
